<template>
	<div v-if="getLoaderShow || getInitLoader" class="popups-container">
		<div class="message" role="status">
			<div class="loader">
				<img
					src="images/loader/mbank-loader.gif"
					alt="Ładowanie danych"
				/>
			</div>
		</div>
	</div>
</template>

<script setup>
import { useStore } from 'vuex';
import { computed, watch } from 'vue';

const store = useStore();

const getLoaderShow = computed(() => {
	return store.getters.getLoaderShow;
});

const getInitLoader = computed(() => {
	return store.getters.getInitLoader;
});

const initWatch = watch(
	() => getLoaderShow.value,
	(newVal) => {
		if (!newVal) {
			setTimeout(() => {
				store.commit('setInitLoader', false);
				initWatch();
			}, 600);
		}
	}
);
</script>
